import { IonButton, IonFab, IonIcon, IonText } from "@ionic/react";
import { sendOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { setShowDocumentPendingModal } from "../../../store/documentShow";
import { selectDocumentStatus } from "../../../store/documentShow/selectors/selectDocumentStatus";
import { selectSigners } from "../../../store/documentShow/selectors/selectSigners";
import { RootState } from "../../../store/rootReducer";
import { selectPendingStatus } from "../../../store/documentUpdate/selectors/selectPendingStatus";
import { useEffect } from "react";

export const ActivateBtn = () => {
  const dispatch = useDispatch();
  const status = useSelector(selectDocumentStatus);
  const signers = useSelector(selectSigners);
  const document = useSelector((state: RootState) => state.documentShow.document);
  const loading = useSelector(selectPendingStatus) === "pending";

  return (
    <>
      {(status?.code === "preparing" || status?.code === "rejected") && (
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonButton
            fill="solid"
            expand="block"
            color="secondary"
            size="large"
            onClick={() => dispatch(setShowDocumentPendingModal(true))}
            disabled= {(document.signatureProvider?.name === "GuardService Inline" && signers.length > 2) || loading}
          >
            <IonIcon icon={sendOutline} />
            <IonText class="ion-padding-start">Enviar a firmar</IonText>
          </IonButton>
        </IonFab>
      )}
    </>
  );
};
